module.exports = __webpack_public_path__ + "static/media/11_l_holsti_14.84_93.52.88396fa0.png";